import type { SRT_Localization } from '..'

import { uk as datesUk } from 'date-fns/locale/uk'

export const SRT_Localization_UK: SRT_Localization = {
	getDateFnsLocalization: () => datesUk,
	language: 'uk',
	actions: 'Дії',
	and: 'і',
	asc: 'ЗРОСТ.',
	cancel: 'Скасувати',
	changeFilterMode: 'Змінити режим фільтрації',
	changeSearchMode: 'Змінити режим пошуку',
	clearFilter: 'Очистити фільтр',
	clearSearch: 'Очистити пошук',
	clearSelection: 'Скасувати вибір',
	clearSort: 'Очистити сортування',
	clickToCopy: 'Натисніть, щоб скопіювати',
	copy: 'Копіювати',
	collapse: 'Згорнути',
	collapseAll: 'Згорнути все',
	columnActions: 'Дії стовпця',
	copiedToClipboard: 'Скопійовано до буферу обміну',
	desc: 'СПАД.',
	dropToGroupBy: 'Перетягніть, щоб групувати по {column}',
	edit: 'Редагувати',
	expand: 'Розгорнути',
	expandAll: 'Розгорнути все',
	filterArrIncludes: 'Включає',
	filterArrIncludesAll: 'Включає всі',
	filterArrIncludesSome: 'Включає деякі',
	filterBetween: 'Між',
	filterBetweenInclusive: 'Між, включно',
	filterByColumn: 'Фільтрувати по {column}',
	filterContains: 'Містить',
	filterEmpty: 'Порожній',
	filterEndsWith: 'Закінчується на',
	filterEquals: 'Дорівнює',
	filterEqualsString: 'Дорівнює',
	filterFuzzy: 'Нечіткий',
	filterGreaterThan: 'Більше ніж',
	filterGreaterThanOrEqualTo: 'Більше ніж або дорівнює',
	filterInNumberRange: 'В діапазоні',
	filterIncludesString: 'Включає',
	filterIncludesStringSensitive: 'Включає (чутливо)',
	filterLessThan: 'Менше ніж',
	filterLessThanOrEqualTo: 'Менше ніж або дорівнює',
	filterMode: 'Режим фільтрації: {filterType}',
	filterNotEmpty: 'Не порожній',
	filterNotEquals: 'Не дорівнює',
	filterStartsWith: 'Починається з',
	filterWeakEquals: 'Дорівнює',
	filteringByColumn: 'Фільтрування по {column} - {filterType} {filterValue}',
	goToFirstPage: 'Перейти на першу сторінку',
	goToLastPage: 'Перейти на останню сторінку',
	goToNextPage: 'Перейти на наступну сторінку',
	goToPreviousPage: 'Перейти на попередню сторінку',
	grab: 'Перетягніть, щоб перемістити',
	groupByColumn: 'Групувати по {column}',
	groupedBy: 'Групувати за',
	hideAll: 'Приховати все',
	hideColumn: 'Приховати стовпець {column}',
	max: 'Макс',
	min: 'Мін',
	move: 'Перемістити',
	noRecordsToDisplay: 'Немає записів для відображення',
	noResultsFound: 'Нічого не знайдено',
	of: 'з',
	or: 'або',
	page: 'Сторінка',
	pin: 'Закріпити',
	pinToLeft: 'Закріпити ліворуч',
	pinToRight: 'Закріпити праворуч',
	resetColumnSize: 'Скинути розмір стовпця',
	resetOrder: 'Скинути порядок',
	rowActions: 'Дії рядка',
	rowNumber: '№',
	rowNumbers: 'Кількість рядків',
	rowsPerPage: 'Рядків на сторінці:',
	save: 'Зберегти',
	search: 'Пошук',
	selectedCountOfRowCountRowsSelected:
		'Вибрано {selectedCount} з {rowCount} рядків',
	select: 'Вибрати',
	showAll: 'Показати все',
	showAllColumns: 'Показати всі стовпці',
	showHideColumns: 'Показати/приховати стовпці',
	showHideFilters: 'Показати/приховати фільтри',
	showHideSearch: 'Показати/приховати пошук',
	sortByColumnAsc: 'Сортувати по {column} за зростанням',
	sortByColumnDesc: 'Сортувати по {column} за спаданням',
	sortedByColumnAsc: 'Сортувати по {column} за зростанням',
	sortedByColumnDesc: 'Сортувати по {column} за спаданням',
	thenBy: 'Потім за',
	toggleDensity: 'Перемкнути щільність',
	toggleFullScreen: 'Перемкнути повноекранний режим',
	toggleSelectAll: 'Перемкнути вибір всіх',
	toggleSelectRow: 'Перемкнути вибір рядка',
	toggleVisibility: 'Перемкнути видимість',
	ungroupByColumn: 'Розгрупувати по {column}',
	unpin: 'Відкріпити',
	unpinAll: 'Відкріпити все',
	resetColumns: 'Скинути стовпці',
	selectMaxColumnsToShow: 'Mакc: {maxColumns} стовпців',
	selectAll: 'Вибрати все',
	resetSorting: 'Скинути сортування',
	addSorting: 'Додати сортування',
	modifySortingToOrganizeYourRows:
		'Змінити сортування для організації ваших рядків.',
	addSortingToOrganizeYourRows:
		'Додати сортування для організації ваших рядків.',
	noSortingApplied: 'Немає сортування',
	sortBy: 'Сортувати по',
	pinned: 'Закріплено',
}
